<div data-cy="warning-snackbar__page" class="disp-flex">
    <mat-icon>warning</mat-icon>
    <div>{{ data?.message }}</div>
    <a data-cy="warning-snackbar__settingsintegratieslink" [routerLink]="settingsIntegratiesLink" (click)="snackBarRef.dismiss();dialog.closeAll();">
        {{'settings.arcgis.arcgis_integratie' | transloco}} 
    </a>
</div>